export const WT_CHECKOUT_STYLED_CONTAINER = 'wt-checkout-styled-container'
